// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1PKF3-","button":"_1rVlR-"};